<template>
    <div class="fingerfood">
        <div class="fingerfood__picture">
            <img class="fingerfood__image" :src="require(`@/assets/${category}/${coverImage}`)" />
            <div class="fingerfood__title">
                <span>{{title}}</span>
            </div>
            <div class="fingerfood__ingredients" v-if="subscription">
                <span>{{subscription}}</span>
            </div>
        </div>
<!--        <div>-->
<!--            <label class="toggle page__toggle" >-->
<!--                <input type="checkbox" id="toggle_checked">-->
<!--                <span class="toggle__button" @click="chooseSize"></span>-->
<!--                <span class="toggle__size-small" @click="chooseSize">&empty; 26cm</span>-->
<!--                <span class="toggle__size-large" @click="chooseSize">&empty; 36cm</span>-->
<!--            </label>-->
<!--        </div>-->
        <div class="fingerfood__price-container">
            <span class="fingerfood__price" v-if="small">{{priceSmall.toString()}} &euro;</span>
<!--            <span class="fingerfood__price" v-else>{{priceLarge.toString()}} &euro;</span>-->
        </div>
        <div class="fingerfood__button-container" @click="showAlert">
            <button class="fingerfood__button" @click="addItemToCart" >In den Warenkorb legen</button>
            <div class="fingerfood__alert" :id="title">
                <span>&#10004; {{title}} in den Warenkorb gelegt</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                small: true
            }
        },
        props: ["id", "title", "priceSmall", "priceLarge", "subscription", "coverImage", "category"],
        methods: {
            chooseSize() {
                this.small = !this.small
            },

            showAlert() {
                const alert = document.getElementById(this.title);
                alert.classList.add("fingerfood__alert-visible");
                setTimeout(function () {
                    alert.classList.remove("fingerfood__alert-visible");
                }, 1000)
            },

            addItemToCart() {
                const options = {
                    category: this.category,
                    itemId: this.id,
                    small: this.small,
                };
                this.$store.dispatch('addItemToCart', options)
            }
        }
    }
</script>

<style scoped>

    .fingerfood {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 70px 0;
    }

    .fingerfood__picture {
        position: relative;
    }

    .fingerfood__image {
        display: block;
        width: 300px;
        height: 300px;
    }

    .fingerfood__title {
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        background: #fcce3d;
        border-radius: 30px;
        font-family: Roboto, sans-serif;
        font-size: 26px;
        color: #2f2b28;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
    }

    .fingerfood__ingredients {
        position: absolute;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        background: #ffffff;
        border-radius: 30px;
        border: 2px solid #2f2b28;
        font-family: Roboto, sans-serif;
        font-size: 14px;
        color: #2f2b28;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
    }

    .fingerfood__button-container {
        position: relative;
        width: 260px;
    }

    .fingerfood__button {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        background: #3d8f41;
        border-radius: 10px;
        border: none;
        font-family: Roboto, sans-serif;
        font-size: 20px;
        color: #ffff;
        outline: none;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
        transition: background-color 0.3s;
        margin: 0 auto;
    }

    .fingerfood__button:hover {
        background: #357538;
    }

    .fingerfood__price {
        font-family: Roboto, sans-serif;
        font-size: 20px;
        color: #2f2b28;
    }

    .fingerfood__price-container {
        width: 100px;
    }

    .fingerfood__alert {
        display: none;
    }

    .fingerfood__alert-visible {
        display: block;
        position: absolute;
        font-family: Roboto, sans-serif;
        font-size: 14px;
        color: #3d8f41;
        top: -40px;
        text-align: center;
        margin: 0 auto;
    }

    .toggle {
        position: relative;
        display: inline-block;
        width: 150px;
        height: 74px;
        user-select: none
    }

    .toggle input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .toggle__button {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fcce3d;
        transition: 0.4s;
        border-radius: 37px;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
    }

    .toggle__button:before {
        position: absolute;
        content: "";
        height: 72px;
        width: 72px;
        border-radius: 50%;
        left: 0;
        top: 0;
        background-color: transparent;
        transition: .4s;
        border: 2px solid #2f2b28;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
    }

    input:focus + .toggle__button {
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
    }

    input:checked + .toggle__button:before {
        transform: translateX(74px);
        border: 2px solid #2f2b28;
    }

    .toggle__button.round {
        border-radius: 50%;
    }

    .toggle__button.round:before {
        border-radius: 50%;
    }

    .toggle__size-small, .toggle__size-large {
        cursor: pointer;
        font-family: Roboto, sans-serif;
        font-size: 18px;
        color: #2f2b28;
        position: absolute;
    }

    .toggle__size-small {
        top: 28px;
        left: 7px;
    }

    .toggle__size-large {
        top: 28px;
        right: 7px;
    }

    @media screen and (max-width: 1000px) {

        .fingerfood {
            flex-direction: column;
            align-items: center;
        }

        .fingerfood__image {
            margin: 20px 0;
        }

        .fingerfood__ingredients {
            bottom: 20px;
        }

        .fingerfood__price {
            display: block;
            margin: 10px 0;
        }

        .fingerfood__alert-visible {
            top: 70px;
        }
    }

</style>